/**
 *
 * Settings
 *
 */

import React from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router';
import { FormattedMessage } from 'lib/intl';
import { makeLink } from 'lib/makeLink';
import { Link } from 'react-router-dom';

// ui
import { Grid, Box, Flex, MenuItem, createStyles, withStyles, WithStyles } from '@domonda/ui';
import * as Icons from 'lib/domonda-icons';

// parts
import { SettingsInvoiceDetailDetectionsPage } from './SettingsInvoiceDetailDetectionsPage';
import { UserClients } from './UserClients';
import { CustomerSettings } from './CustomerSettings';

const styles = createStyles(({ palette }) => ({
  navigation: {
    backgroundColor: palette.surface,
    padding: '20px 20px 20px 0',
    borderRight: '1px solid #CFDDE2',
  },
  sidebarItem: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '15px',
    cursor: 'pointer',
    color:'#4A4A4A',
    padding: '0 5px',
    fontWeight: 500,
    textDecoration: 'none',
    margin: '0 0 20px 23px',

    '& .icon': {
      marginRight: '5px',
    }

  },
  menuItemContainer: {
    display: 'flex',
    borderBottom: '1px solid #d8d8d8',
  },
  menuItem: {
    display: 'inline-block',
    color: '#4A4A4A',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: 500,
    width: 'auto',
    padding: '8px 16px',

    '& span': {
      display: 'inline',
    }
  },
  activeMenuItem: {
    backgroundColor: '#F4F7F8',
  }

}));

export type SettingsPageProps = RouteComponentProps;

const SettingsPage: React.FC<SettingsPageProps & WithStyles<typeof styles>> = (props) => {
  const { match, classes } = props;
  const paramsString = window.location.pathname;

  return (
    <Grid
      container
      fill
      template={`
      'navigation content' 1fr
      / 225px 1fr`}
    >
      <Grid className={classes.navigation} area="navigation" overflowing>
        <Flex container direction="column">
          <Flex item>
            <Link className={classes.sidebarItem} to="/">
              <Icons.Documents className='icon' />
              <FormattedMessage id="DOCUMENTS_DOCUMENTS" />
            </Link>
          </Flex>
          <Flex style={{display:'none'}} item>
            <Link className={classes.sidebarItem} to="dashboard">
              <Icons.DashboardIcon className='icon' />
              Dashboard
            </Link>
          </Flex>
        </Flex>
      </Grid>
      <Grid area="content" overflowing>
        <div className={classes.menuItemContainer}>
          <MenuItem
            component={makeLink({ to: match.url })}
            className={`${classes.menuItem} ${paramsString === '/settings' && classes.activeMenuItem}`}
          >
            <FormattedMessage id="SETTINGS_DETECTIONS_ORDER" />
          </MenuItem>
          <MenuItem
            component={makeLink({ to: '/settings/userClients' })}
            className={`${classes.menuItem} ${paramsString === '/settings/userClients' && classes.activeMenuItem}`}
          >
            <FormattedMessage id="SETTINGS_Clients" />
          </MenuItem>
          <MenuItem
            component={makeLink({ to: '/settings/customerSettings' })}
            className={`${classes.menuItem} ${paramsString === '/settings/customerSettings' && classes.activeMenuItem}`}
          >
            <FormattedMessage id="SETTINGS_CustomerConfiguration" />
          </MenuItem>
        </div>
        <Box padding={2}>
          <Switch>
            <Route path={match.path} exact component={SettingsInvoiceDetailDetectionsPage} />
            <Route path={'/settings/userClients'} exact component={UserClients} />
            <Route path={'/settings/customerSettings'} exact component={CustomerSettings} />
          </Switch>
        </Box>
      </Grid>
    </Grid>
  );
};

const ComposedSettingsPage = withStyles(styles)(SettingsPage);
export { ComposedSettingsPage as SettingsPage };
